import {CAPTURE} from '@shared/brandCapture';
export function captureBatchError(files:ReadonlyArray<{size:number}>):string|null {
 const total=files.reduce((sum,file)=>sum+file.size,0);
 return total>CAPTURE.maxTotalBytes?`These screenshots total ${(total/1024/1024).toFixed(1)} MB. The limit is ${CAPTURE.maxTotalBytes/1024/1024} MB per upload. Remove a screenshot or use smaller files.`:null;
}
export function recoverCaptureUpload(data:Record<string,unknown>,uploadError:unknown):Record<string,unknown>{
 if(data.status==='awaiting_upload')throw uploadError;
 return data;
}
export function captureErrorMessage(error:unknown):string{
 const failure=error as {status?:number;code?:string;timedOut?:boolean};
 if(failure.status===413||failure.code==='CAPTURE_TOO_LARGE')return 'The screenshot upload is too large. Use files up to 5 MB each and 20 MB total, then try again.';
 if(failure.code==='CAPTURE_INVALID_IMAGE')return 'Use 4–8 valid PNG, JPEG or WebP screenshots, up to 5 MB each and 20 MB total.';
 if(failure.status===402)return 'You need more credits to analyze these screenshots.';
 if(failure.status===429)return 'Analysis is busy right now. Your screenshots are still selected; try again shortly.';
 if(failure.timedOut)return 'Analysis took too long. Your screenshots are still selected; analyze again starts a fresh request.';
 if(failure.code==='CAPTURE_INTERRUPTED')return 'The upload connection ended before analysis completed. Your screenshots are still selected; analyze again starts a fresh request.';
 return 'Analysis could not finish. Your screenshots are still selected; analyze again starts a fresh request.';
}
